module.exports = require("./ar-SS.d.ts");